import { render } from "./UserScoreTable.vue?vue&type=template&id=41001c6d&scoped=true"
import script from "./UserScoreTable.vue?vue&type=script&lang=js"
export * from "./UserScoreTable.vue?vue&type=script&lang=js"

import "./UserScoreTable.vue?vue&type=style&index=0&id=41001c6d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41001c6d"]])

export default __exports__